import { defineStore } from "pinia";
import { ref, reactive } from "vue";
import svc from "@/services/accounting/budget-revenues.service";
import { toast } from "@/utils/toast";
import { MODULE_KEYS } from "@/config/modules-registry";
import { guardPlanModule } from "@/utils/planAccess";

export const useBudgetRevenueStore = defineStore("budgetRevenues", () => {
  const items = ref([]);
  const loading = ref(false);
  const error = ref(null);

  const meta = ref({
    total: 0,
    per_page: 25,
    current_page: 1,
  });

  const filters = reactive({
    q: "",
    from_date: "",
    to_date: "",
  });

  async function fetch(params = {}) {
    if (!(await guardPlanModule(MODULE_KEYS.FA_ACCOUNTING))) {
      items.value = [];
      return;
    }

    loading.value = true;
    error.value = null;

    try {
      const page = params.page ?? meta.value.current_page ?? 1;

      const res = await svc.fetch({
        q: filters.q || "",
        from_date: filters.from_date || "",
        to_date: filters.to_date || "",
        page,
        per_page: meta.value.per_page,
        ...params,
      });

      const payload = res.data;
      items.value = payload.data || [];

      meta.value = {
        total: payload.meta?.total ?? items.value.length,
        per_page: payload.meta?.per_page ?? meta.value.per_page,
        current_page: payload.meta?.current_page ?? page,
      };
    } catch (e) {
      console.error("Failed to fetch budget revenues", e);
      error.value = e;
      toast.error?.("Failed to load budget revenues");
    } finally {
      loading.value = false;
    }
  }

  async function remove(id) {
    if (!id) return;
    try {
      await svc.remove(id);
      toast.success?.("Revenue deleted");
      await fetch({ page: meta.value.current_page });
    } catch (e) {
      console.error("Failed to delete revenue", e);
      toast.error?.("Failed to delete revenue");
    }
  }

  return {
    items,
    loading,
    error,
    meta,
    filters,
    fetch,
    remove,
  };
});
